
import { defineComponent } from "vue";
import { IEnrollmentAppliedDiscountstModel, IIndividualEnrollmentModel, ITuitionDiscountsModel } from "@/interfaces/modules";
import EnrollmentDiscountsService from "@/api/Collection/EnrollmentAppliedDiscountsService";
import IndividualEnrollmentService from "@/api/Enrollment/IndividualEnrollmentService";
import TuitionDiscountsService from "@/api/Collection/TuitionDiscountsService";
import store from "@/store";

export default defineComponent({
  name: "EnrollmentDiscountsContent",
  props: ['record'],
  data() {
    return {
      enrollments: [] as IIndividualEnrollmentModel[],
      discounts: [] as ITuitionDiscountsModel[],
      form: {
        loading: true,
        dialog: false,
        wasValidated: false,
        record: {} as IEnrollmentAppliedDiscountstModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "DiscountId", label: "Descuento", sortable: true },
          { key: "AppliedAmount", label: "Porcentaje aplicado (%)", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IEnrollmentAppliedDiscountstModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: IEnrollmentAppliedDiscountstModel) =>
          [item.EnrollmentId, item.DiscountId, item.AppliedAmount]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  async mounted() {
    await this.load();
    this.enrollments = await IndividualEnrollmentService.GetEnrollments();
    this.discounts = await TuitionDiscountsService.GetDiscounts();
  },
  methods: {
    async load() {
      this.table.loading = true;
      if (this.record.Id > 0)
        this.table.records = await EnrollmentDiscountsService.GetEnrollmentDiscounts({ EnrollmentId: this.record.Id } as any);
      this.table.loading = false;
    },
    async edit(data: IEnrollmentAppliedDiscountstModel) {
      this.form.record = await EnrollmentDiscountsService.GetEnrollmentDiscountById({ Id: data.Id } as any);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        Id: 0,
        EnrollmentId: 0,
        DiscountId: 0,
        AppliedAmount: 0,
        CreatedBy: 0,
        CreatedDate: "",
      } as IEnrollmentAppliedDiscountstModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await EnrollmentDiscountsService.PostEnrollmentDiscount(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
